import { createFeatureSelector, createSelector } from "@ngrx/store";
import { intermediateFeatureKey } from "./intermediate-chart.reducer";

export const selectIntermediateState = createFeatureSelector(intermediateFeatureKey);

export const selectIntermediate = createSelector(
  selectIntermediateState,
  (state: any) => state
);
